import { call, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { request } from '@wix/da-http-client/pkg/request';
import { MediaSourceType } from '../types';
import { getCurrentMediaSource, getCurrentTierId } from '../selectors';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
import { FetchType } from '../../Stream/base/types';
export function fakeResponse({ params }) {
    if (process.env.NODE_ENV !== 'production') {
        const { deviationsByType } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        const { Chance } = require('chance'); // eslint-disable-line global-require
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        const { folderId, offset, limit } = params;
        if (folderId === -999) {
            return {
                hasMore: false,
                nextOffset: 0,
                deviations: []
            };
        }
        const randomDeviations = new Chance().pickset(deviationsByType.pixel.concat(deviationsByType.statuses).concat(deviationsByType.image).concat(deviationsByType.edgeCases).concat(deviationsByType.journal).concat(deviationsByType.literature), limit);
        return {
            hasMore: offset + limit < deviationsByType.image.length,
            nextOffset: offset + limit,
            deviations: randomDeviations.slice(0, limit)
        };
    }
}
function* fetch(url, params) {
    const response = yield call(request, {
        method: 'get',
        url,
        params
    }, fakeResponse);
    return response;
}
function* handleDeviationStreamFetch(action) {
    const { streamId } = action;
    const { tierId, mediaSource, offset, limit } = yield select((state)=>({
            tierId: getCurrentTierId(state),
            mediaSource: getCurrentMediaSource(state),
            offset: withOffset.selectors.getNextOffset(state, streamId),
            limit: selectors.getItemsPerFetch(state, streamId)
        }));
    const url = 'tier/content';
    const params = {
        tier_deviationid: tierId,
        section: mediaSource === MediaSourceType.TIER_DEVIATIONS ? 'deviations' : 'posts',
        offset,
        limit,
        mature_content: true
    };
    const response = yield call(fetch, url, params);
    if (!response) {
        yield put(withOffset.actions.fetchFailure({
            streamId,
            fetchType: FetchType.Next,
            errorMsg: 'Failed to fetch'
        }));
        return;
    }
    const { hasMore, deviations: results, nextOffset } = response;
    const normalized = results && normalizeDeviations(results);
    var _normalized_result, _normalized_entities;
    yield put(withOffset.actions.fetchSuccessDeduped({
        streamId,
        hasMore: results ? !!hasMore : false,
        items: (_normalized_result = normalized === null || normalized === void 0 ? void 0 : normalized.result) !== null && _normalized_result !== void 0 ? _normalized_result : [],
        entities: (_normalized_entities = normalized === null || normalized === void 0 ? void 0 : normalized.entities) !== null && _normalized_entities !== void 0 ? _normalized_entities : {},
        nextOffset: nextOffset !== null && nextOffset !== void 0 ? nextOffset : undefined
    }));
}
export default handleDeviationStreamFetch;
